import { Button } from '@/components/Button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';

type LinkedAccountDesyncProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending?: boolean;
};

export default function LinkedAccountDesync({
  isOpen,
  onClose,
  onConfirm,
  isPending = false,
}: LinkedAccountDesyncProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="flex w-[640px] flex-col overflow-hidden rounded-sm border-0 p-0 shadow-layer3">
        <div className="flex shrink-0 items-center border-b border-solid border-border px-lg py-md">
          <DialogTitle className="text-heading-xs!">同期解除</DialogTitle>
        </div>
        <DialogDescription asChild>
          <div className="p-lg text-body-md! text-main!">
            <span>同期を解除を開始しますか？</span>
            <br />
            <span>マッチしている求人以外は自動で削除されます</span>
          </div>
        </DialogDescription>
        <div className="flex shrink-0 items-center justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button type="button" color="secondary" onClick={onClose} disabled={isPending}>
            キャンセル
          </Button>
          <Button type="button" color="danger" onClick={onConfirm} disabled={isPending}>
            解除する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
